
    import './styles.scoped.css';
    export default {
  "active-uap": "awsui_active-uap_12jti_1lr5y_5"
};
  